import { useTheme, useMediaQuery } from "@mui/material";

/**
 * Hook for consistent mobile breakpoint detection.
 * Returns true when viewport is below 'md' breakpoint (< 900px).
 *
 * Use this hook instead of inline useMediaQuery calls for consistency.
 *
 * @example
 * const isMobile = useIsMobile();
 * return isMobile ? <MobileView /> : <DesktopView />;
 */
export function useIsMobile(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down("md"));
}

/**
 * Hook for tablet detection (between sm and md breakpoints).
 * Returns true when viewport is between 600px and 899px.
 */
export function useIsTablet(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.between("sm", "md"));
}

/**
 * Hook for desktop detection.
 * Returns true when viewport is at or above 'md' breakpoint (>= 900px).
 */
export function useIsDesktop(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.up("md"));
}
